"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthorizedError = void 0;
const BaseError_1 = require("./BaseError");
class UnauthorizedError extends BaseError_1.BaseError {
    constructor(description = "Unauthorized") {
        super("UnauthorizedError", 401, description, true);
    }
}
exports.UnauthorizedError = UnauthorizedError;
